<template>
  <div class="recaptcha">
    <div v-if="siteKey" class="g-recaptcha" :data-sitekey="siteKey"></div>
    <div v-if="showLegend" class="recaptcha-legend">
      <template v-if="isFrenchSelected">
        Ce site est protégé par reCAPTCHA Enterprise et la
        <a target="_blank" :href="privacyUrlFr">Politique de confidentialité</a> et les
        <a target="_blank" :href="termsUrlFr">Conditions d'utilisation</a> de Google s'appliquent.
      </template>
      <template v-else>
        This site is protected by reCAPTCHA Enterprise and the Google
        <a target="_blank" :href="privacyUrl">Privacy Policy</a> and
        <a target="_blank" :href="termsUrl">Terms of Service</a> apply.
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "GoogleReCaptcha",
  data() {
    return {
      privacyUrl: "https://policies.google.com/privacy",
      termsUrl: "https://policies.google.com/terms",
      privacyUrlFr: "https://policies.google.com/privacy?hl=fr-CA",
      termsUrlFr: "https://policies.google.com/terms?hl=fr-CA",
      siteKey: process.env.VUE_APP_GOOGLE_RECAPTCHA_SITE_ID
    };
  },
  props: {
    showLegend: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(["selectedLocale"]),
    isFrenchSelected() {
      return this.selectedLocale?.languageType?.name === "fr";
    },
    legendHtml() {
      if (this.isFrenchSelected) {
        return `Ce site est protégé par reCAPTCHA Enterprise et la
          <a target="_blank" rel="noopener noreferrer" href="${this.privacyUrl}">Politique de confidentialité</a> et les
          <a target="_blank" rel="noopener noreferrer" href="${this.termsUrl}">Conditions d'utilisation</a> de Google s'appliquent.`;
      }

      return `This site is protected by reCAPTCHA Enterprise and the Google
        <a target="_blank" rel="noopener noreferrer" href="${this.privacyUrl}">Privacy Policy</a> and
        <a target="_blank" rel="noopener noreferrer" href="${this.termsUrl}">Terms of Service</a> apply.`;
    }
  }
};
</script>

<style scoped>
.recaptcha {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.recaptcha-legend {
  font-size: 12px;
  color: #666;
}

.recaptcha-legend a {
  color: inherit;
  text-decoration: underline;
}
</style>
